module.exports = __webpack_public_path__ + "icon_marketing.png?2ce78c7e3d790e1c6dceb9289a79b2c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_marketing.png
// module id = 232
// module chunks = 0